import { render, staticRenderFns } from "./linkedbutton.vue?vue&type=template&id=873b28ea&scoped=true"
import script from "./linkedbutton.vue?vue&type=script&lang=js"
export * from "./linkedbutton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873b28ea",
  null
  
)

export default component.exports